import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const treeListItemDefaultVariants = {
  "size": "md",
  "color": "success"
}
const treeListItemCompoundVariants = [
  {
    "color": "success",
    "active": true,
    "css": {
      "root": {
        "--tree-list-item-bg": "token(colors.positive.surface.high)",
        "_hover": {
          "--tree-list-item-bg": "token(colors.positive.surface.base)"
        }
      },
      "titleArea": {
        "color": "positive.text.base"
      },
      "icon": {
        "color": "positive.icon.base"
      },
      "count": {
        "color": "positive.text.base"
      }
    }
  },
  {
    "color": "info",
    "active": true,
    "css": {
      "root": {
        "--tree-list-item-bg": "token(colors.info.surface.high)",
        "_hover": {
          "--tree-list-item-bg": "token(colors.info.surface.base)"
        }
      },
      "titleArea": {
        "color": "info.text.base"
      },
      "icon": {
        "color": "info.icon.base"
      },
      "count": {
        "color": "info.text.base"
      }
    }
  },
  {
    "color": "error",
    "active": true,
    "css": {
      "root": {
        "--tree-list-item-bg": "token(colors.critical.surface.high)",
        "_hover": {
          "--tree-list-item-bg": "token(colors.critical.surface.base)"
        }
      },
      "titleArea": {
        "color": "critical.text.base"
      },
      "icon": {
        "color": "critical.icon.base"
      },
      "count": {
        "color": "critical.text.base"
      }
    }
  }
]

const treeListItemSlotNames = [
  [
    "root",
    "treeListItem__root"
  ],
  [
    "body",
    "treeListItem__body"
  ],
  [
    "dragHandle",
    "treeListItem__dragHandle"
  ],
  [
    "checkbox",
    "treeListItem__checkbox"
  ],
  [
    "icon",
    "treeListItem__icon"
  ],
  [
    "titleArea",
    "treeListItem__titleArea"
  ],
  [
    "count",
    "treeListItem__count"
  ],
  [
    "actionArea",
    "treeListItem__actionArea"
  ],
  [
    "actionAreaGradient",
    "treeListItem__actionAreaGradient"
  ],
  [
    "actionAreaContent",
    "treeListItem__actionAreaContent"
  ],
  [
    "showOnHover",
    "treeListItem__showOnHover"
  ],
  [
    "depthItem",
    "treeListItem__depthItem"
  ],
  [
    "iconButton",
    "treeListItem__iconButton"
  ],
  [
    "switchCheckbox",
    "treeListItem__switchCheckbox"
  ],
  [
    "switchCheckboxIcon",
    "treeListItem__switchCheckboxIcon"
  ],
  [
    "switchCheckboxCheckbox",
    "treeListItem__switchCheckboxCheckbox"
  ],
  [
    "depthPipe",
    "treeListItem__depthPipe"
  ],
  [
    "depthPipeLine",
    "treeListItem__depthPipeLine"
  ]
]
const treeListItemSlotFns = /* @__PURE__ */ treeListItemSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, treeListItemDefaultVariants, getSlotCompoundVariant(treeListItemCompoundVariants, slotName))])

const treeListItemFn = memo((props = {}) => {
  return Object.fromEntries(treeListItemSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const treeListItemVariantKeys = [
  "size",
  "color",
  "selected",
  "disabled",
  "active"
]
const getVariantProps = (variants) => ({ ...treeListItemDefaultVariants, ...compact(variants) })

export const treeListItem = /* @__PURE__ */ Object.assign(treeListItemFn, {
  __recipe__: false,
  __name__: 'treeListItem',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: treeListItemVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md"
  ],
  "color": [
    "success",
    "info",
    "error"
  ],
  "selected": [
    "true"
  ],
  "disabled": [
    "true"
  ],
  "active": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, treeListItemVariantKeys)
  },
  getVariantProps
})